import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import LayoutLoginHomepage from "../components/LayoutLoginHomepage";

const API_URL = process.env.REACT_APP_API_URL || 
  `${window.location.protocol}//${window.location.hostname}:8000`;

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      // Verify the token is still valid
      axios.get(`${API_URL}/verify-session`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(() => {
        window.location.href = "/";
      }).catch(() => {
        // Token invalid, stay on login page
        localStorage.removeItem("authToken");
      });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/login`, {
        username,
        password,
      });

      // Store token in localStorage
      localStorage.setItem("authToken", response.data.token);
      
      // Force a page reload to ensure AuthContext picks up the token
      window.location.href = "/";
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayoutLoginHomepage>
      <div className="min-h-screen flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <div className="bg-gray-800 rounded-2xl shadow-2xl p-8">
            <h1 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-blue-300 to-blue-500 bg-clip-text text-transparent">
              Personal Finance
            </h1>

            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <label className="block text-gray-300 mb-2 text-sm font-medium">
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 
                           focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  required
                  autoFocus
                />
              </div>

              <div>
                <label className="block text-gray-300 mb-2 text-sm font-medium">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white border border-gray-600 
                           focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  required
                />
              </div>

              {error && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="p-3 rounded-lg bg-red-500/10 border border-red-500/50"
                >
                  <p className="text-red-400 text-sm text-center">{error}</p>
                </motion.div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 rounded-lg bg-gradient-to-r from-blue-500 to-sky-600 
                         hover:opacity-90 transition font-semibold text-white
                         disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </LayoutLoginHomepage>
  );
}